import React, {Component} from "react";
import { flowRight as compose } from "lodash";
import NoteForm from "./NoteForm";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import { cancelEditNote, requestDeleteNote } from "../NotesActions";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import { connect } from "react-redux";
import { Map, fromJS, List } from "immutable";
import { validatePresence } from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";


function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "title");
  return errors.toJS();
}

class EditNoteFormContainer extends Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = {
      noteId: this.props.noteId,
      status: values.get("status"),
      title: values.get("title"),
      descriptionHtml: values.get("descriptionHtml", ""),
      tags: values.get("tags", List()).toJS()
    }
    return this.props.updateNote(updatedValues)
      .then((response) => {
        if (response.data.updateNote.errors.length <= 0) {
          this.props.cancelEditNote(this.props.noteId);
        } else {
          let errors = createValidationErrors(response.data.updateNote.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });
  }

  handleDelete() {
    this.props.requestDeleteNote(this.props.noteId);
  }

  handleCancel() {
    this.props.cancelEditNote(this.props.noteId);
  }

  render() {
    let {loading, error, note} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />

    let noteData = fromJS(note);

    let initialValues = fromJS({
      status: noteData.get("status"),
      title: noteData.get("title"),
      descriptionHtml: noteData.get("descriptionHtml"),
      tags: noteData.get("tags", [])
    });

    return (
      <NoteForm
        initialValues={initialValues}
        errors={this.state.errors}
        validate={validateForm}
        showDelete={true}
        onDelete={this.handleDelete.bind(this)}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}

const GET_NOTE = gql`
  query note($noteId: ID!) {
    note(noteId: $noteId) {
      noteId
      status
      title
      descriptionHtml
      tags
    }
  }
`;

const UPDATE_NOTE = gql`
  mutation updateNote($data: UpdateNoteInput!) {
    updateNote(input: $data) {
      errors { key message }
    }
  }
`;

const withQueries = compose(
  graphql(GET_NOTE, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        noteId: props.noteId
      }
    })
  }),
  graphql(UPDATE_NOTE, {
    props: ({ mutate }) => ({
      updateNote: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);


export default connect(null, {cancelEditNote, requestDeleteNote})(withQueries(EditNoteFormContainer));